(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lbc-card"] && !Shopify.designMode) return;
  try {
    (function(){
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine=window.matchMedia('(hover: hover)').matches;
  if(!fine||reduce)return;
  function pixel(c){
    var box=c.querySelector('.lbc-cbox'),cv=box&&box.querySelector('canvas.lbc-cpx'),A=box&&box.querySelector('img.lbc-a'),B=box&&box.querySelector('img.lbc-b');
    if(!cv||!A||!B)return;
    if(!(A.complete&&A.naturalWidth&&B.complete&&B.naturalWidth))return;
    var ctx=cv.getContext('2d'),off=document.createElement('canvas'),oc=off.getContext('2d');
    c._lbcRun=(c._lbcRun||0)+1;var id=c._lbcRun,W=box.clientWidth,H=box.clientHeight,seq=[[A,5],[A,11],[A,20],[B,20],[B,11],[B,5]],i=0;
    cv.width=W;cv.height=H;B.style.opacity=0;
    (function step(){
      if(id!==c._lbcRun)return;
      if(i>=seq.length){B.style.opacity=1;cv.style.opacity=0;return;}
      try{var b=seq[i][1],w=Math.max(1,Math.round(W/b)),h=Math.max(1,Math.round(H/b));off.width=w;off.height=h;oc.drawImage(seq[i][0],0,0,w,h);ctx.imageSmoothingEnabled=false;ctx.clearRect(0,0,W,H);ctx.drawImage(off,0,0,w,h,0,0,W,H);cv.style.opacity=1;}
      catch(err){cv.style.opacity=0;B.style.opacity=1;return;}
      i++;setTimeout(step,50);
    })();
  }
  document.addEventListener('mouseover',function(e){
    var c=e.target.closest&&e.target.closest('.lbc-card');
    if(!c||(e.relatedTarget&&c.contains(e.relatedTarget)))return;
    var v=c.querySelector('video.lbc-vid');
    if(v){v.preload='auto';var p=v.play();if(p&&p.catch)p.catch(function(){});}
    if(c.classList.contains('lbc-f-pix'))pixel(c);
  });
  document.addEventListener('mouseout',function(e){
    var c=e.target.closest&&e.target.closest('.lbc-card');
    if(!c||(e.relatedTarget&&c.contains(e.relatedTarget)))return;
    var v=c.querySelector('video.lbc-vid');
    if(v){v.pause();v.currentTime=0;}
    if(c._lbcRun!==undefined){c._lbcRun++;var cv=c.querySelector('canvas.lbc-cpx'),B=c.querySelector('img.lbc-b');if(cv)cv.style.opacity=0;if(B)B.style.opacity='';}
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["media-thumb"] && !Shopify.designMode) return;
  try {
    (function(){
  if(window.__lbcThumbV)return;
  window.__lbcThumbV=true;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saver=navigator.connection&&navigator.connection.saveData;
  if(reduce||saver||!('IntersectionObserver' in window))return;
  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){
      var v=e.target;
      if(e.isIntersecting){
        if(!v.getAttribute('src'))v.src=v.getAttribute('data-src');
        var p=v.play();
        if(p&&p.catch)p.catch(function(){});
      }else{v.pause();}
    });
  },{threshold:.25});
  function scan(root){
    (root||document).querySelectorAll('video.lbc-thumb-v:not([data-lbc-t])').forEach(function(v){
      v.setAttribute('data-lbc-t','1');
      v.addEventListener('playing',function(){
        var m=v.closest('.hdt-thumbnail__media');
        if(m)m.classList.add('lbc-tv-on');
      });
      io.observe(v);
    });
  }
  var queued=false;
  function queueScan(){
    if(queued)return;
    queued=true;
    requestAnimationFrame(function(){queued=false;scan();});
  }
  scan();
  document.addEventListener('DOMContentLoaded',function(){scan();});
  document.addEventListener('shopify:section:load',function(e){scan(e.target);});
  if('MutationObserver' in window){
    new MutationObserver(queueScan).observe(document.documentElement,{childList:true,subtree:true});
  }
  document.addEventListener('visibilitychange',function(){
    if(document.hidden){
      document.querySelectorAll('video.lbc-thumb-v').forEach(function(v){v.pause();});
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
